import React, { useRef, useCallback, useEffect } from 'react';
import './modalStyle.css';

const ConfettiBurst = ({
  emojis = ['🎉', '✨', '💥'],
  count = 40,
  time = 3000,
  onInit,
}) => {
  const containerRef = useRef(null);
  const timeoutRef = useRef(null);

  const start = useCallback(
    (duration = time, x = window.innerWidth / 2, y = window.innerHeight / 2) => {
      const container = containerRef.current;
      if (!container) return;

      const fragment = document.createDocumentFragment();
      const elements = [];

      for (let i = 0; i < count; i++) {
        const emoji = document.createElement('span');
        emoji.textContent = emojis[Math.floor(Math.random() * emojis.length)];
        emoji.className = 'confetti-burst-emoji';

        const angle = Math.random() * Math.PI * 2;
        const spread = Math.random() * 400 + 100;

        emoji.style.left = `${x}px`;
        emoji.style.top = `${y}px`;
        emoji.style.setProperty('--dx', `${Math.cos(angle) * spread}px`);
        emoji.style.setProperty('--dy', `${Math.sin(angle) * spread}px`);
        emoji.style.animationDuration = `${duration}ms`;
        emoji.style.fontSize = `${Math.random() * 10 + 18}px`;

        fragment.appendChild(emoji);
        elements.push(emoji);
      }

      // Batch DOM insertion
      requestAnimationFrame(() => {
        container.appendChild(fragment);
      });

      timeoutRef.current = setTimeout(() => {
        elements.forEach((el) => el.remove());
      }, duration);
    },
    [count, emojis, time]
  );

  // Call onInit ONLY once
  useEffect(() => {
    if (typeof onInit === 'function') {
      onInit(start);
    }
  }, [onInit, start]);

  // Cleanup
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return <div ref={containerRef} className="confetti-burst-container" />;
};

export default ConfettiBurst;
